import React from 'react';
import PropTypes from 'prop-types';
import css from './RenderUserSubscriptionMaybe.module.css'; // create styling as needed
import { Icons } from '../../../../../components';

const formatFeatureDetails = (key, value) => {
  const formattedKey = key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());

  if (typeof value === 'object') {
    if (value.frequency) {
      return `${value.frequency} ${formattedKey} Per Billing Cycle`;
    } else if (value.enabled) {
      return `${formattedKey} Included`;
    } else {
      return `${formattedKey} Not Included`;
    }
  }

  return value === true ? `${formattedKey} Included` : `${formattedKey} Not Included`;
};

const CustomFeatureList = ({ features }) => {
  if (!features || typeof features !== 'object') return null;

  const featureList = Object.entries(features).map(([key, value]) => ({
    key,
    name: key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()),
    details: formatFeatureDetails(key, value),
  }));

  return (
    <ul className={css.featuresList}>
      {featureList.map(({ key, name, details }) => (
        <li key={key} className={css.featureItem}>
          <Icons name="checkListIcon" />
          <span>
            <strong>{name}</strong>: {details}
          </span>
        </li>
      ))}
    </ul>
  );
};

CustomFeatureList.propTypes = {
  features: PropTypes.object.isRequired,
};

export default CustomFeatureList;
